import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { AUTH } from '@/constants/testIds';
import { toast } from 'sonner';

export const SignupPage = () => {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [referral, setReferral] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const ref = params.get('ref');
    if (ref) setReferral(ref.toUpperCase());
  }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await signup(email, password, referral || null);
      toast.success('OPERATOR_PROVISIONED');
      nav('/pricing');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Signup failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-16 px-6">
      <div className="text-[10px] tracking-[0.4em] uppercase text-[#38BDF8] mb-3">
        // ENROLL_OPERATOR
      </div>
      <h1 className="text-3xl font-bold uppercase tracking-tighter mb-8">
        Create Operator<span className="caelix-caret"></span>
      </h1>
      <form data-testid={AUTH.signupForm} onSubmit={submit} className="c-card space-y-4">
        <div>
          <label className="c-label" htmlFor="signup-email">Operator Email</label>
          <input
            id="signup-email"
            data-testid={AUTH.signupEmail}
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="operator@caelix.io"
            className="c-input"
          />
        </div>
        <div>
          <label className="c-label" htmlFor="signup-password">Passphrase (6+ chars)</label>
          <input
            id="signup-password"
            data-testid={AUTH.signupPassword}
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            className="c-input"
          />
        </div>
        <div>
          <label className="c-label" htmlFor="signup-referral">Referral Code (optional)</label>
          <input
            id="signup-referral"
            data-testid={AUTH.signupReferral}
            type="text"
            value={referral}
            onChange={(e) => setReferral(e.target.value.toUpperCase())}
            placeholder="e.g. ABCD1234"
            className="c-input tracking-[0.15em]"
            maxLength={12}
          />
          <div className="text-[10px] text-gray-600 tracking-widest uppercase mt-2">
            &gt; both operators earn +1 month on your first paid upgrade
          </div>
        </div>
        <button
          data-testid={AUTH.signupSubmit}
          type="submit"
          disabled={busy}
          className="c-btn-primary w-full"
        >
          {busy ? 'PROVISIONING…' : 'CREATE_OPERATOR'}
        </button>
        <div className="text-xs text-gray-500 pt-2 border-t border-[#3F3F46]">
          Existing operator?{' '}
          <Link
            data-testid={AUTH.signupGoLogin}
            to="/login"
            className="text-[#38BDF8] hover:underline uppercase tracking-widest"
          >
            INITIATE_SESSION
          </Link>
        </div>
      </form>
    </div>
  );
};

export default SignupPage;
